import { Card, PageDescription } from '../style';
import { useContext, useEffect, useState } from 'react';

import { IServiceOfUser } from '../model';
import MassiveRoleHandler from '../componets/MassiveRoleEditor/MassiveRoleHandler';
import Select from 'react-select';
import { get } from 'lodash';
import { getUserServices } from '../api/fetch';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { isServiceManager } from '../utils';
import { LoggedUserContext } from '../componets/UserContext/userContext';
import { AccessLevel } from '../model/enum';

const Wrapper = styled.section`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 880px;
    gap: 1rem;
`;

const selectStyles = {
    control: (styles: any) => ({
        ...styles,
        width: '100%',
        marginBottom: '20px',
        borderColor: '#F90',
        colors: '#f90',
        borderRadius: '8px',
    }),
};

const selectTheme = (theme: any) => ({
    ...theme,
    borderRadius: 0,
    colors: {
        ...theme.colors,
        primary: 'rgba(255, 153, 0, 0.6)',
        primary25: 'rgba(255, 153, 0, 0.6)',
        primary50: 'rgba(255, 153, 0, 0.6)',
        primary75: 'rgba(255, 153, 0, 0.6)',
    },
});

export const MassiveRoleEditor = () => {
    const [selectedService, setSelectedService] = useState<IServiceOfUser | null>(null);
    const { loggedUser } = useContext(LoggedUserContext);

    const isSm = isServiceManager(loggedUser?.accessLevel as AccessLevel);

    const { isError, isLoading, services } = getUserServices(isSm ? loggedUser?.userObjectId : undefined);
    const { t } = useTranslation();

    const handleSelectChange = (id: string) => {
        //Dalla lista dei servizi correnti seleziona quello con l'id corrispondente e lo setta come selected in modo da poterlo visualizzare nel form di modifica
        const selected = services.serviceForUserList.find((service: IServiceOfUser) => service.id === id);
        setSelectedService(selected);
    };

    const serviceList = get(services, 'serviceForUserList', []);

    //Crea una lista di opzioni per il select
    const options: { value: string; label: string; serviceArea?: string }[] = serviceList.map((service: IServiceOfUser) => {
        return { value: service.id, label: service.name, serviceArea: service.serviceAreaClientId };
    });

    return (
        <>
            {isError && <Card>{t('errors.requestFailed')}</Card>}
            {isLoading && <Card>{t('generic.loading')}</Card>}

            {serviceList && (
                <Wrapper>
                    <PageDescription>{t('routes.editMassivRole')}</PageDescription>
                    <Select
                        theme={selectTheme}
                        styles={selectStyles}
                        placeholder={t('table.clmService')}
                        options={serviceList.map((s: IServiceOfUser) => ({
                            value: s.id,
                            label: s.name,
                            id: s.id,
                            dataversId: s.dataverseId,
                            serviceArea: s.serviceAreaClientId,
                            description: s.description,
                        }))}
                        onChange={(newValue: any) => handleSelectChange(newValue?.value)}
                        filterOption={(option, inputValue) => {
                            if (!inputValue) return true;
                            const q = inputValue.toLowerCase();
                            return (
                                (option.label ?? '').toLowerCase().includes(q) ||
                                ((option.data as any).serviceArea ?? '').toLowerCase().includes(q) ||
                                ((option.data as any).id ?? '').toLowerCase().includes(q) ||
                                ((option.data as any).description ?? '').toLowerCase().includes(q)
                            );
                        }}
                    />
                    {selectedService && <MassiveRoleHandler selectStyles={selectStyles} selectTheme={selectTheme} service={selectedService} />}
                </Wrapper>
            )}
        </>
    );
};
